export default function getShippingProvince(state) {
	return !!state.checkout.shipping.province ? state.checkout.shipping.province : null;
}



// WEBPACK FOOTER //
// ./src/store/utils/getShippingProvince.js